import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';

interface VibesState {
  vibe: { text: string; icon: string };
}

const initialState: VibesState = {
  vibe: { text: '', icon: '' },
};

export const vibesSlice = createSlice({
  name: 'vibes',
  initialState,
  reducers: {
    clearVibe: (state) => {
      state.vibe = { text: '', icon: '' };
    },
    setVibe: (state, action: PayloadAction<{ text: string; icon: string }>) => {
      state.vibe = action.payload;
    },
  },
});

export const { clearVibe, setVibe } = vibesSlice.actions;
export const getVibe = (state: RootState) => state.vibes.vibe;
export default vibesSlice.reducer;
